// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label_1TTF1{align-items:center;background:var(--cp-secondary-4);background-position:10px 5px;background-repeat:no-repeat;background-size:16px;border-radius:0 4px 0 0;bottom:0;color:var(--cp-black);display:flex;font-size:14px;font-style:normal;font-weight:600;left:0;line-height:20px;padding:3px 10px 3px 34px;position:absolute;text-transform:capitalize;z-index:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "label_1TTF1"
};
module.exports = ___CSS_LOADER_EXPORT___;
